import { ComplaintTypes } from "./actionTypes"

//grid


export const getComplaintListLoading = (lazyState: any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_LOADING,
    lazyState
  }
}

export const getComplaintListSuccess = (invoice: any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_SUCCESS,
    payload: invoice
  }
}

export const getComplaintListError = (error: any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_FAIL,
    payload: error
  }
}

export const getComplaintFormByIdLoading = (id:any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_BY_ID_LOADING,
    payload:id
  }
}

export const getComplaintFormByIdSuccess = (data: any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_BY_ID_SUCCESS,
    payload: data
  }
}

export const getComplaintFormByIdError = (error: any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_BY_ID_FAIL,
    payload: error
  }
}

export const createComplaintFormLoading = (payload:any,id:any=0) => {
  return {
    type: ComplaintTypes.CREATE_COMPLAINT_LOADING,
    payload:{data:payload,id:id}
  }
}

export const createComplaintFormSuccess = (data: any) => {
  
  return {
    type: ComplaintTypes.CREATE_COMPLAINT_SUCCESS,
    payload: data
  }
}

export const createComplaintFormError = (error: any) => {
  return {
    type: ComplaintTypes.CREATE_COMPLAINT_FAIL,
    payload: error
  }
}

export const deleteComplaintLoading = (params:any) => {
  return {
    type: ComplaintTypes.DELETE_COMPLAINT_LOADING,
    payload:params
  }
}

export const deleteComplaintSuccess = (data: any,undo:boolean) => {
  
  return {
    type: ComplaintTypes.DELETE_COMPLAINT_SUCCESS,
    payload: data,
    undo
  }
}

export const deleteComplaintError = (error: any) => {
  return {
    type: ComplaintTypes.DELETE_COMPLAINT_FAIL,
    payload: error
  }
}

export const getComplaintDropdownLoading = (id:any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_DROPDOWN_LOADING,
    payload:id
  }
}

export const getComplaintDropdownSuccess = (data: any) => {
  
  return {
    type: ComplaintTypes.GET_COMPLAINT_DROPDOWN_SUCCESS,
    payload: data,
  }
}

export const getComplaintDropdownError = (error: any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_DROPDOWN_FAIL,
    payload: error
  }
}

export const clearComplaintDropdown = () => {
  return {
    type: ComplaintTypes.CLEAR_COMPLAINT_DROPDOWN,
  }
}

export const getPrefixDropdownLoading = () => {
  return {
    type: ComplaintTypes.GET_PREFIX_DROPDOWN_LOADING,
  }
}

export const getPrefixDropdownSuccess = (data: any) => {
  
  return {
    type: ComplaintTypes.GET_PREFIX_DROPDOWN_SUCCESS,
    payload: data,
  }
}

export const getPrefixDropdownError = (error: any) => {
  return {
    type: ComplaintTypes.GET_PREFIX_DROPDOWN_FAIL,
    payload: error
  }
}

export const getAllComplaintDropdownLoading = () => {
  return {
    type: ComplaintTypes.GET_ALL_COMPLAINT_DROPDOWN_LOADING,
  }
}

export const getAllComplaintDropdownSuccess = (data: any) => {
  
  return {
    type: ComplaintTypes.GET_ALL_COMPLAINT_DROPDOWN_SUCCESS,
    payload: data,
  }
}

export const getAllComplaintDropdownError = (error: any) => {
  return {
    type: ComplaintTypes.GET_ALL_COMPLAINT_DROPDOWN_FAIL,
    payload: error
  }
}

export const getComplaintDocumentLoading = (id:any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_FILES_LOADING,
    payload:id
  }
}

export const getComplaintDocumentSuccess = (data: any) => {
  
  return {
    type: ComplaintTypes.GET_COMPLAINT_FILES_SUCCESS,
    payload: data,
  }
}

export const getComplaintDocumentError = (error: any) => {
  return {
    type: ComplaintTypes.GET_COMPLAINT_FILES_FAIL,
    payload: error
  }
}

export const deleteComplaintDocumentLoading = (id:any,docId:any) => {
  return {
    type: ComplaintTypes.DELETE_COMPLAINT_FILES_LOADING,
    payload:{id,docId}
  }
}

export const deleteComplaintDocumentSuccess = (data: any) => {
  
  return {
    type: ComplaintTypes.DELETE_COMPLAINT_FILES_SUCCESS,
    payload: data,
  }
}

export const deleteComplaintDocumentError = (error: any) => {
  return {
    type: ComplaintTypes.DELETE_COMPLAINT_FILES_FAIL,
    payload: error
  }
}

export const clearComplaintMessage = () => {
  return {
    type: ComplaintTypes.CLEAR_MESSAGE,
  }
}

export const resetComplaintMessage = () => {
  return {
    type: ComplaintTypes.RESET_MESSAGE,
  }
}
